export default __webpack_public_path__ + "static/media/logotipo.c6bd3a1d.png";